<template>
  <div class="wrapper">
    <div class="title-wrapper">
      <h2 class="title">
        {{ lang === 'en' ? 'Daily Usage' : '过去30天的每日调用量' }}
      </h2>
      <p class="total">
        Total:
        <strong>{{ Object.values(apiList).reduce((acc, cur) => acc + cur.total_count, 0) }}</strong>
      </p>
    </div>
    <!-- wip.. -->
    <el-form :rules="rules" ref="date" :model="date" class="date-form">
      <div class="input-wrapper">
        <el-form-item label="Start" prop="start">
          <el-input
            type="text"
            name="start"
            min="2013-01-01"
            :max="new Date().toLocaleDateString('en-ca')"
            :placeholder="
              new Date(new Date().setMonth(new Date().getMonth() - 1)).toLocaleDateString('en-ca')
            "
            v-model="date.start"
            onfocus="(this.type='date')"
          ></el-input>
        </el-form-item>
        <el-form-item label="End" prop="end">
          <el-input
            type="text"
            name="end"
            min="2013-01-01"
            :max="new Date().toLocaleDateString('en-ca')"
            :placeholder="new Date().toLocaleDateString('en-ca')"
            v-model="date.end"
            onfocus="(this.type='date')"
          ></el-input>
        </el-form-item>
        <el-form-item label="Key" prop="apiKey">
          <el-input
            type="text"
            name="apiKey"
            v-model="date.apiKey"
            onfocus="(this.type='text')"
          ></el-input>
        </el-form-item>
      </div>

      <el-form-item>
        <el-button type="primary" @click="fetchAPICountBetween('date')">Search</el-button>
      </el-form-item>
    </el-form>
    <ul class="list">
      <!-- :load="log(sortObject(apiList))" -->
      <li v-for="([key, value], index) in sortObject(apiList)" :key="index" class="item">
        <details v-if="value.details">
          <summary>{{ key }} </summary>
          <ul class="list">
            <li v-for="(value, key) in value.details" :key="key" class="sub-item">
              <div class="space-between">
                <p class="extra-key">{{ key }}</p>
              </div>
              <div>
                <div class="space-between">
                  <p>Total Count:</p>
                  <p class="bold">{{ value.total_count }}</p>
                </div>
                <div class="space-between">
                  <p>Malware Scan Count:</p>
                  <p class="bold">{{ value.malware_detection }}</p>
                </div>
                <div class="space-between">
                  <p>Junk Clean Count:</p>
                  <p class="bold">{{ value.clean_count }}</p>
                </div>
                <div class="space-between">
                  <p>Wifi Scan Count:</p>
                  <p class="bold">{{ value.wifi_count }}</p>
                </div>
                <div class="space-between">
                  <p>Malware Detected:</p>
                  <p class="bold">{{ value.malware_query_count }}</p>
                </div>
              </div>
            </li>
          </ul>
        </details>
        <details v-else>
          <summary>{{ key }} </summary>
          <ul class="list">
            <li class="">
              <div class="space-between">
                <p>Total Count:</p>
                <p class="bold">{{ value.total_count }}</p>
              </div>
            </li>
            <li class="">
              <div class="space-between">
                <p>Malware Scan Count:</p>
                <p class="bold">{{ value.malware_detection }}</p>
              </div>
            </li>
            <li class="">
              <div class="space-between">
                <p>Junk Clean Count:</p>
                <p class="bold">{{ value.clean_count }}</p>
              </div>
            </li>
            <li class="">
              <div class="space-between">
                <p>Wifi Scan Count:</p>
                <p class="bold">{{ value.wifi_count }}</p>
              </div>
            </li>
            <li class="">
              <div class="space-between">
                <p>Malware Detected:</p>
                <p class="bold">{{ value.malware_query_count }}</p>
              </div>
            </li>
          </ul>
        </details>
        <p class="bold daily-total">{{ value.total_count }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
  import axios from 'axios'
  import { Message } from 'element-ui'

  export default {
    name: 'DailyUsage',
    props: {
      apiList: {
        type: Object,
        require: true
      }
    },
    data() {
      return {
        date: {
          start: '',
          end: '',
          apiKey: ''
        },
        rules: {
          start: [{ required: true, message: this.$t('errMsg.startDateErr'), trigger: 'blur' }],
          end: [{ required: true, message: this.$t('errMsg.endDateErr'), trigger: 'blur' }],
          apiKey: [{ required: false, message: this.$t('errMsg.apiKeyErr'), trigger: 'blur' }]
        }
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    methods: {
      // debug
      log(item) {
        console.log({item})
      },
      // object -> return 2d array in descending order
      sortObject(obj) {
        return Object.entries(obj).sort((a, z) => {
          if (a[0] === z[0]) return 0;
          else return (a[0] > z[0]) ? -1 : 1;
        })
      },
      fetchAPICountBetween: async function(formName) {
        try {
          this.$refs[formName].validate(async valid => {
            if (valid) {
              let data = {
                start: this.date.start,
                end: this.date.end,
                apiKey: this.date.apiKey ? this.date.apiKey : null
              }
              let response;
              if(!data.apiKey) {
                response = await axios.post('/api/product/api-count/between', data)
              } else {
                try {
                  response = await axios.post('/api/product/api-count/between-for-one-key', data)
                } catch (err) {
                  console.log({ err })
                  Message({ type: 'error', message: err.response.data.message, showClose: true })
                }
              }
              console.log({response});

              // emit the data to "dashboard" component
              this.$root.$emit('dailyAPICallList', response.data.data)
            }
          })
        } catch (err) {
          console.log({ err })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 24px;
    background-color: $white;
    border-radius: 8px;
    box-shadow: 1px 2px 4px hsla(210, 29%, 24%, 0.5);
  }

  .title-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-size: 21px;
  }

  .date-form {
    display: flex;
    gap: 16px 32px;
  }

  .input-wrapper {
    display: flex;
    gap: 16px;
  }

  .el-form-item {
    display: flex;
    margin-bottom: 0px; // cancel default style
  }

  @media screen and (max-width: 700px) {
    .date-form {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  @media screen and (max-width: 550px) {
    .input-wrapper {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .total {
    & strong {
      font-size: 21px;
    }
  }

  .list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .item {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 16px 24px;
    border-radius: 8px;
    border: 1px solid hsl(210, 29%, 24%);
  }

  .sub-item {
    padding: 16px 24px;
    border-radius: 8px;
    border: 1px solid hsl(210, 29%, 24%);
  }

  details {
    grid-column: 1 / -1;
  }

  details summary {
    cursor: pointer;
  }

  details[open] summary {
    margin-bottom: 16px;
  }

  .bold {
    font-weight: bold;
  }

  .daily-total {
    justify-self: end;
    position: absolute;
    top: 16px;
    right: 24px;
  }

  .space-between {
    display: flex;
    justify-content: space-between;
  }

  .extra-key {
    width: 100%;
    overflow: visible;
    white-space: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/DailyUsage.vue